// removed by extract-text-webpack-plugin
module.exports = {"BestFood":"BestFood__BestFood__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/BestFood/BestFood.scss
// module id = 184
// module chunks = 0